jQuery(document).ready(function( $ ){
	// START JQUERY





	// END JQUERY
});
